<template>
  <div class="rounded-md bg-black p-2 shadow-md lg:p-4" :data-post-id="post.id">
    <template v-if="post.content?.content">
      <div class="post-tip-tap">
        <PostRenderer
          v-for="(element, i) in post.content?.content"
          :key="`content-${i}`"
          :node="element"
          :is-active="isActive"
          class="relative"
        />
      </div>
    </template>
    <RouterLink :to="{ name: 'FanzonePost', params: { id: post.id } }">
      <div class="pt-2 lg:pt-4">
        <div class="flex items-center justify-between pb-2">
          <span class="flex text-sm text-white opacity-40">{{ displayDateTime }}</span>
          <ShareButton
            :title="post.title"
            :text="post.description"
            :media="post.thumbnailImage"
            :url="postUrl || ''"
            @click="preventRouterNavigation"
          />
        </div>
        <div>
          <h2 class="w-full font-Helvetica-Neue-Roman text-white/80">{{ post.title }}</h2>
          <div v-if="post.description" class="pt-2 text-sm text-white/80">
            {{ post.description }}
          </div>
        </div>
      </div>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import moment from 'moment';
import type { PostInterface } from './post.interface';

// Components
import ShareButton from '@modules/Buttons/ShareButton.vue';
import PostRenderer from '@modules/Post/TipTap/PostRenderer.vue';

const props = defineProps<{
  post: PostInterface;
  isActive?: boolean;
}>();

const postUrl = computed(() => `${import.meta.env.VITE_HOME_URL}/fanzone/${props.post.id}`);

const displayDateTime = computed(() => {
  const scheduledAt = moment(props.post.startAt);
  const createdAt = moment(props.post.createdAt);
  if (scheduledAt.isAfter(createdAt)) {
    return scheduledAt.format('D MMMM');
  }
  return createdAt.format('D MMMM');
});

const preventRouterNavigation = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
};
</script>
